<style lang="scss" scoped>
.test {
  width: 1920px;
  height: 1080px;
  overflow-y: auto;
  background: rgb(0, 0, 0);
  padding: 20px;
  pointer-events: all;
  position: absolute;
  top: 0;
  left: 0;
  .title {
    font-size: 15px;
    color: white;
    padding-bottom: 20px;
    border-bottom: 1px solid white;
  }
  .component-item {
    background: rgb(37, 37, 37);
    margin-top: 20px;
    margin-bottom: 50px;
    padding: 20px;
    .c-title {
      font-size: 20px;
      color: white;
    }
    .text {
      font-size: 30px;
      color: white;
    }
    .main {
      margin-top: 20px;
      padding: 20px;
      background: rgb(60, 60, 60);
    }
    .table {
      width: 650px;
      height: 338px;
    }
    .code {
      font-size: 22px;
      color: white;
      background: rgb(0, 132, 255);
      padding: 20px;
      cursor: pointer;
    }

    .tips {
      margin-top: 20px;
      font-size: 22px;
      color: white;
      background: rgb(0, 195, 255);
      padding: 20px;
      cursor: pointer;
    }
  }
}

pre {
  margin-bottom: 20px;
}
.today-table {
  width: 416px;
  height: 128px;
}
</style>

<template>
  <div class="test">
    <div class="component-item">
      <div class="c-title">11.pannel弹框</div>
      <div class="main">
        <div style="width: 900px">
          <pannel-box
            :headerData="headerData"
            :isPull="isPull"
            :isDisable="isDisable"
          >
          </pannel-box>
        </div>
      </div>
      <div class="code">
        <pre> {{ html12 }}</pre>
        <el-button @click="copy(html12)">复制代码</el-button>
      </div>
    </div>
    <div class="component-item">
      <div class="c-title">1.圆形进度条</div>
      <div class="main">
        <div style="width:150px;height:150px">
          <custom-progress-circle
            :title="'营收分析'"
            :text="'289,00'"
            :value="0"
            color="#F1802F"
          ></custom-progress-circle>
        </div>
      </div>
      <div class="code">
        <pre> {{ html1 }}</pre>
        <el-button @click="copy(html1)">复制代码</el-button>
      </div>

      <div class="main">
        <div style="width:300px;height:300px">
          <custom-progress-circle
            :title="'运营大盘'"
            :text="'35/178'"
            :value="75"
            color="#2D82FF"
          ></custom-progress-circle>
        </div>
      </div>
      <div class="code">
        <pre> {{ html2 }}</pre>
        <el-button @click="copy(html2)">复制代码</el-button>
      </div>
      <div class="tips">
        该组件需要父级盒子定义好大小
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">2.坐标进度条</div>
      <div class="main">
        <div style="width: 220px">
          <custom-progress-line
            :value="50"
            :splitCount="40"
          ></custom-progress-line>
        </div>
      </div>
      <div class="code">
        <pre> {{ html3 }}</pre>
        <el-button @click="copy(html3)">复制代码</el-button>
      </div>

      <div class="tips">注意这个宽度是继承父级的，高度不用设置</div>
    </div>

    <div class="component-item">
      <div class="c-title">3.广告</div>
      <div class="main">
        <div style="width: 220px">
          <advertisement
            content="白日依山尽，黄河入海流，欲穷千里目，更上一层楼"
          ></advertisement>
        </div>
      </div>
      <div class="code">
        <pre> {{ html4 }}</pre>
        <el-button @click="copy(html4)">复制代码</el-button>
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">4.年月日选择</div>
      <div class="main">
        <div style="width: 220px">
          <time-type-select
            v-model="timeValue"
            @change="timeChangeEvent"
          ></time-type-select>
          <div style="color: white; font-size: 20px">
            当前选中：{{ timeValue }}
          </div>
        </div>
      </div>
      <div class="code">
        <pre> {{ html5 }}</pre>
        <el-button @click="copy(html5)">复制代码</el-button>
      </div>

      <div class="tips">
        注意，组件直接绑定变量，如果需要监听，需要watch变量或者调用@change事件，可以选择的值
        day,month,year,
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">5.侧边栏边框组件</div>
      <div class="main">
        <div style="width: 420px">
          <custom-plane
            title="资源共享"
            iconImg="https://fanyi-cdn.cdn.bcebos.com/static/translation/img/header/logo_e835568.png"
          ></custom-plane>
        </div>
      </div>
      <div class="code">
        <pre> {{ html6 }}</pre>
        <el-button @click="copy(html6)">复制代码</el-button>
      </div>
      <div class="tips">
        注意,可以不传值,直接获取一个空白面板
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">6.图表组件</div>
      <div class="main">
        <div style="width: 420px;height: 84px;">
          <custom-charts :dataList="dataList"></custom-charts>
        </div>
      </div>
      <div class="code">
        <pre> {{ html7 }}</pre>
        <el-button @click="copy(html7)">复制代码</el-button>
      </div>
      <div class="tips">
        注意,通过传递dataList中的x轴数据:dataList.x,图例数据dataList.y实现图表
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">7.楼层控件组件</div>
      <div class="main">
        <div style="width: 420px">
          <custom-frame :shareList="[2, 3, 4, 5, '共享区域']"></custom-frame>
        </div>
      </div>
      <div class="code">
        <pre> {{ html8 }}</pre>
        <el-button @click="copy(html8)">复制代码</el-button>
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">8.雷达图组件</div>
      <div class="main">
        <div style="width: 220px;height:200px">
          <!-- <custom-radarCharts :radarList="radarList"></custom-radarCharts> -->
        </div>
      </div>
      <div class="code">
        <pre> {{ html9 }}</pre>
        <el-button @click="copy(html9)">复制代码</el-button>
      </div>
    </div>

    <div class="component-item">
      <div class="c-title">9.筛选表格组件</div>
      <div class="main">
        <div style="width:416px;height:678px">
          <custom-table></custom-table>
        </div>
        <div class="today-table">
          <auto-table :header="header" :tableData="tableData"></auto-table>
        </div>
      </div>
      <div class="code">
        <pre> {{ html10 }}</pre>
        <el-button @click="copy(html10)">复制代码</el-button>
      </div>
    </div>
    <div class="component-item">
      <div class="c-title">10.告警面板</div>
      <div class="main">
        <div style="width: 900px">
          <alarm-panel
            :panelIcon="require('@/assets/compImg/icon/equipment.png')"
            panelModel="消防"
            warnTime="2020/12/31 20:00:58"
            warnMessage="9号喷淋传感器发生故障，请立即处理。"
            :isDispose="true"
          ></alarm-panel>
        </div>
      </div>
      <div class="code">
        <pre> {{ html11 }}</pre>
        <el-button @click="copy(html11)">复制代码</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isPull: false,
      isDisable: false,
      header: [
        {
          name: "拜访时间",
          key: "dayTime",
          width: "160",
          align: "center",
        },
        {
          name: "访客信息",
          key: "dayInfo",
          width: "136",
          align: "center",
        },
        {
          name: "拜访地址",
          key: "dayArea",
          width: "80",
          align: "center",
        },
      ],
      tableData: [
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
      ],
      headerData: {
        name: "环境监测",
        value: "B# B09A A 3# 楼配电间D11 进线 3",
        status: "正常",
        id: "4176023525972246528",
      },
      html1: `<custom-progress-circle :title="'运营大盘'" :text="'289,00'" :value="0" color="#F1802F"></custom-progress-circle>`,
      html2: `<custom-progress-circle :title="'运营大盘'" :text="'35/178'" :value="75" color="#2D82FF"></custom-progress-circle>`,
      html3: `<custom-progress-line :value="50" :splitCount="40" ></custom-progress-line>`,
      html4: `<advertisement content="白日依山尽，黄河入海流，欲穷千里目，更上一层楼"></advertisement>`,
      html5: `<time-type-select v-model="timeValue" @change="timeChangeEvent"></time-type-select>`,
      html6: `<custom-plane title="资源共享" iconImg="https://fanyi-cdn.cdn.bcebos.com/static/translation/img/header/logo_e835568.png"></custom-plane>`,
      html7: `<custom-charts :dataList="dataList"></custom-charts>`,
      html8: `<custom-frame :shareList="[2,3,4,5,'共享区域']"></custom-frame>`,
      html9: `<custom-radarCharts :radarList="radarList"></custom-radarCharts>`,
      html10: `<custom-table></custom-table>`,
      html11: `<alarm-panel
            :panelIcon="require('@/assets/compImg/icon/equipment.png')"
            panelModel="消防"
            warnTime="2020/12/31 20:00:58"
            warnMessage="9号喷淋传感器发生故障，请立即处理。"
            :isDispose="true"
          ></alarm-panel>`,
      html12: `<pannel-box></pannel-box>`,
      timeValue: "day",
      dataList: {
        x: [],
        y: [],
      },
      radarList: [],
    };
  },
  methods: {
    copy(data) {
      navigator.clipboard.writeText(data);
      this.$message.success("代码复制成功!");
    },
    timeChangeEvent(type) {
      console.log("时间变换", type);
    },
  },
  created() {},
};
</script>
